import { DropdownMenu } from "@zapier/product-nav";
import { useSetAtom } from "jotai";
import { isKeyboardShortcutsModalOpenAtom } from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

const HelpMenu = () => {
  const { emitEventOnHelpClick } = useEmitUserInteractionEvents();
  const setIsKeyboardShortcutsModalOpen = useSetAtom(
    isKeyboardShortcutsModalOpenAtom,
  );

  const helpMenuItems = [
    {
      title: "Help center",
      action: () => {
        window.open("https://canvas.zapier.app", "_blank");
      },
      id: "help-center",
    },
    {
      title: "Contact us",
      action: () => {
        window.open(
          "https://npsup.zapier.app/contact-us?product=Canvas",
          "_blank",
        );
      },
      id: "contact-us",
    },
    {
      title: "Keyboard shortcuts",
      action: () => {
        setIsKeyboardShortcutsModalOpen(true);
      },
      id: "keyboard-shortcuts",
    },
  ];

  const actions = {
    ...helpMenuItems.reduce(
      (obj, item) => ({ ...obj, [item.id]: item.action }),
      {},
    ),
  };
  const handleAction = (key: React.Key) => {
    const action = actions[key as keyof typeof actions];
    if (action) {
      if (typeof action === "function") {
        (action as typeof Function)();
      }
    }
  };

  return (
    <DropdownMenu
      iconBefore="navHelp"
      iconAfter="arrowSmallDown"
      label="Help"
      onAction={handleAction}
      placement="bottom right"
      onClose={emitEventOnHelpClick}
    >
      {helpMenuItems.map((item) => (
        <DropdownMenu.Item key={item.title} id={item.id}>
          {item.title}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu>
  );
};
export default HelpMenu;
